import { useCallback } from 'react'

const useFieldFocusChange = (registerdField, setFocusedFields) => {
  const onFocus = useCallback(
    e => {
      e.persist()
      setFocusedFields(state => ({
        ...state,
        [e.target.name]: true,
      }))
    },
    [setFocusedFields]
  )

  const onBlur = useCallback(
    e => {
      e.persist()
      setFocusedFields(state => ({
        ...state,
        [e.target.name]: false,
      }))
      if (registerdField.onBlur) {
        registerdField.onBlur(e)
      }
    },
    [setFocusedFields, registerdField]
  )

  return { ...registerdField, onFocus, onBlur }
}

export default useFieldFocusChange
